import { Request } from '../../Servidor/Request';

export class LogRelatoryInteractor {
    public fetchLogs(filters: Array<any>): PromiseLike<any> {
        return new Promise((res, rej) => {
            return new Request().requestPost("relatorio/logs", { ...filters }).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchLogsRelatory(filters: Array<any>): PromiseLike<any> {
        let name = 'Relatorio_logs.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/logs-pdf", { ...filters }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}